export class Cell {

	constructor() {
		//CELL DATA
		this.row = 0;
		this.column = 0;
		this.width = 0;
		this.length = 0;
		this.estructura = '';
		this.grid = null;

		// 2D data
		this.instanceId = -1;
		this.mesh = null;
		this.position = null;
		this.selected = false;
		this.visible = true;
	}

	init( row, column, rowLength, columnWidth, estructura, grid ) {
		this.row = row;
		this.column = column;
		this.width = columnWidth;
		this.length = rowLength;
		this.estructura = estructura;
		this.grid = grid;
	}
}